import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { adminValidation } from "../library/service";
import ProductRetrieve from "../admin/ProductRetrieve";
import AdminCred from "../admin/AdminCred";
import ProductDetailsUpload from "../admin/ProductDetailsUpload";
import ImageDetailsUpload from "../admin/ImageDetailsUpload";
import User from "../admin/User";
import OrderHistoryAdmin from "../admin/OrderHistoryAdmin";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";

const DownloadReports = () => {
  const [nav, setNav] = useState({
    home: true,
    productSearch: false,
    userSearch: false,
    productUpload: false,
    userUpload: false,
    productImageUpload: false,
    orderHistory: false,
  });
  const [admin, setAdmin] = useState(false);
  const navigate = useNavigate();

  // State for CSV report download
  const [reportFrom, setReportFrom] = useState("");
  const [reportTo, setReportTo] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadError, setDownloadError] = useState("");

  // State for Customer Onboarding Status download
  const [onboardingFrom, setOnboardingFrom] = useState("");
  const [onboardingTo, setOnboardingTo] = useState("");
  const [onboardingLoading, setOnboardingLoading] = useState(false);
  const [onboardingError, setOnboardingError] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { adminAuth(); }, []);

  const adminAuth = async () => {
    const authorized = await adminValidation();
    if (!authorized) {
      navigate('/');

    }
    else if
      (authorized && authorized.data.is_admin) {
      setAdmin(true);
    }
    else {
      navigate("/unAuthorized");
    }
  };

  const handleNav = (event) => {
    const name = event.target.name.toLowerCase();
    setNav({
      home: name === "home",
      productSearch: name === "productsearch",
      userSearch: name === "usersearch",
      productUpload: name === "productupload",
      productImageUpload: name === "productimageupload",
      userUpload: name === "userupload",
      orderHistory: name === "orderhistory"
    });
  };

  const isValidDateStr = (str) => /^\d{4}-\d{2}-\d{2}$/.test(str);

  const blobToText = async (blob) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsText(blob);
  });

  const downloadOrderReport = async () => {
    setDownloadError("");

    // Basic validation
    if (!reportFrom || !reportTo) {
      setDownloadError("Please select both From and To dates.");
      return;
    }
    if (!isValidDateStr(reportFrom) || !isValidDateStr(reportTo)) {
      setDownloadError("Dates must be in format yyyy-mm-dd.");
      return;
    }
    const fromDate = new Date(reportFrom);
    const toDate = new Date(reportTo);
    if (fromDate > toDate) {
      setDownloadError("From date cannot be after To date.");
      return;
    }


    setDownloadLoading(true);
    try {
      const token = window.sessionStorage.getItem("JWTtoken");

      const data = JSON.stringify({
        start_date: reportFrom,
        end_date: reportTo,
      });

      const config = {
        method: "post",
        url: `${backendBookartUrl}/orderReport`,
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "application/json",
          Accept: "text/csv",
        },
        data: data,
        responseType: "blob",
      };

      const response = await axios(config);

      const contentType =
        response.headers["content-type"] || response.headers["Content-Type"] || "";
      if (contentType.toLowerCase().includes("application/json")) {
        const text = await blobToText(response.data);
        try {
          const json = JSON.parse(text);
          setDownloadError(json.message || "No data found.");
        } catch {
          setDownloadError(text || "No data found.");
        }
        return;
      }

      const blob = new Blob([response.data], { type: "text/csv" });

      // Determine filename from Content-Disposition if provided
      let filename = `order_report_${reportFrom}_${reportTo}.csv`;
      const disp = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]);
      if (disp) {
        const match = /filename="?([^"]+)"?/.exec(disp);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      if (error.response && error.response.data) {
        try {
          const ct =
            error.response.headers?.["content-type"] ||
            error.response.headers?.["Content-Type"] ||
            "";
          if (ct.toLowerCase().includes("application/json")) {
            const text = await blobToText(error.response.data);
            try {
              const json = JSON.parse(text);
              setDownloadError(json.message || `Request failed with status code ${error.response.status}`);
            } catch {
              setDownloadError(text || `Request failed with status code ${error.response.status}`);
            }
          } else {
            setDownloadError(`Request failed with status code ${error.response.status}`);
          }
        } catch {
          setDownloadError(error.message || "Failed to download report.");
        }
      } else {
        setDownloadError(error.message || "Failed to download report.");
      }
    } finally {
      setDownloadLoading(false);
    }
  };

  const downloadOnboardingReport = async () => {
    setOnboardingError("");

    if (!onboardingFrom || !onboardingTo) {
      setOnboardingError("Please select both From and To dates.");
      return;
    }
    if (!isValidDateStr(onboardingFrom) || !isValidDateStr(onboardingTo)) {
      setOnboardingError("Dates must be in format yyyy-mm-dd.");
      return;
    }
    if (new Date(onboardingFrom) > new Date(onboardingTo)) {
      setOnboardingError("From date cannot be after To date.");
      return;
    }

    setOnboardingLoading(true);
    try {
      const token = window.sessionStorage.getItem("JWTtoken");

      const data = JSON.stringify({
        start_date: onboardingFrom,
        end_date: onboardingTo,
      });

      const config = {
        method: "post",
        url: `${backendBookartUrl}/customerReport`,
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "application/json",
          Accept: "text/csv",
        },
        data: data,
        responseType: "blob",
      };

      const response = await axios(config);

      const contentType =
        response.headers["content-type"] || response.headers["Content-Type"] || "";
      if (contentType.toLowerCase().includes("application/json")) {
        const text = await blobToText(response.data);
        try {
          const json = JSON.parse(text);
          setOnboardingError(json.message || "No data found.");
        } catch {
          setOnboardingError(text || "No data found.");
        }
        return;
      }

      const blob = new Blob([response.data], { type: "text/csv" });

      let filename = `customer_onboarding_status_${onboardingFrom}_${onboardingTo}.csv`;
      const disp = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]);
      if (disp) {
        const match = /filename="?([^"]+)"?/.exec(disp);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      if (error.response && error.response.data) {
        try {
          const ct =
            error.response.headers?.["content-type"] ||
            error.response.headers?.["Content-Type"] ||
            "";
          if (ct.toLowerCase().includes("application/json")) {
            const text = await blobToText(error.response.data);
            try {
              const json = JSON.parse(text);
              setOnboardingError(json.message || `Request failed with status code ${error.response.status}`);
            } catch {
              setOnboardingError(text || `Request failed with status code ${error.response.status}`);
            }
          } else {
            setOnboardingError(`Request failed with status code ${error.response.status}`);
          }
        } catch {
          setOnboardingError(error.message || "Failed to download report.");
        }
      } else {
        setOnboardingError(error.message || "Failed to download report.");
      }
    } finally {
      setOnboardingLoading(false);
    }
  };

  if (!admin) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader />
        <div className="container">
          <section>
            <div>
              <div className="margin-top-30">
                <Link className="es-link colored font-16" to="/home">
                  <svg viewBox="0 0 54 128" height="16" width="11">
                    <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
                  </svg>
                  Back to home
                </Link>
              </div>
              <h3 className="margin-top-30">Bookart Admin</h3>
              <div className="row margin-top-30">
                <div className="col-3">
                  <nav id="admin-menu">
                    <ol className="es-list none">
                      <li>
                        <button type="button"
                          className={nav.home ? "es-link selected pointer" : "es-link pointer"}
                          name="home"
                          onClick={handleNav}
                        >
                          Downloads
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="productsearch"
                          className={nav.productSearch ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          Product Search
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="usersearch"
                          className={nav.userSearch ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          User Search
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="productupload"
                          className={nav.productUpload ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          Product Upload
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="productimageupload"
                          className={nav.productImageUpload ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          Product Image Upload
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="userupload"
                          className={nav.userUpload ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          User Upload
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          name="orderhistory"
                          className={nav.orderHistory ? "es-link selected pointer" : "es-link pointer"}
                          onClick={handleNav}
                        >
                          Order History
                        </button>
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="col-9">
                  {nav.home &&
                    <div className="container min-height60">
                      <h2>Download Reports</h2>
                      <div className="margin-top-30" style={{ border: "1px solid #dee2e6", borderRadius: "4px", padding: "24px" }}>
                        <h5>Download Orders Report (CSV)</h5>
                        <div className="row">
                          <div className="col-4 margin-top-30">
                            <p>
                              <label htmlFor="id-size3">From</label>
                            </p><p>
                              <input
                                className="es-input"
                                type="date"
                                value={reportFrom}
                                onChange={(e) => setReportFrom(e.target.value)}
                                placeholder="yyyy-mm-dd"
                              />
                            </p>
                          </div>
                          <div className="col-4 margin-top-30">
                            <p>
                              <label htmlFor="id-size3">To</label>
                            </p><p>
                              <input
                                className="es-input"
                                type="date"
                                value={reportTo}
                                onChange={(e) => setReportTo(e.target.value)}
                                placeholder="yyyy-mm-dd"
                              />
                            </p>
                          </div>
                        </div>
                        <div className="margin-top-30"></div>
                        <div>
                          <p>
                            <button
                              className="es-button primary"
                              onClick={downloadOrderReport}
                              disabled={downloadLoading}
                            >
                              {downloadLoading ? "Preparing..." : "Download"}
                            </button>
                          </p>
                        </div>
                        {downloadError && (
                          <div className="margin-top-10" style={{ color: "red" }}>
                            {downloadError}
                          </div>
                        )}
                      </div>

                      <div className="margin-top-30" style={{ border: "1px solid #dee2e6", borderRadius: "4px", padding: "24px" }}>
                        <h5>Download Customer Onboarding Status (CSV)</h5>
                        <div className="row">
                          <div className="col-4 margin-top-30">
                            <p>
                              <label htmlFor="id-onboarding-from">From</label>
                            </p><p>
                              <input
                                id="id-onboarding-from"
                                className="es-input"
                                type="date"
                                value={onboardingFrom}
                                onChange={(e) => setOnboardingFrom(e.target.value)}
                                placeholder="yyyy-mm-dd"
                              />
                            </p>
                          </div>
                          <div className="col-4 margin-top-30">
                            <p>
                              <label htmlFor="id-onboarding-to">To</label>
                            </p><p>
                              <input
                                id="id-onboarding-to"
                                className="es-input"
                                type="date"
                                value={onboardingTo}
                                onChange={(e) => setOnboardingTo(e.target.value)}
                                placeholder="yyyy-mm-dd"
                              />
                            </p>
                          </div>
                        </div>
                        <div className="margin-top-30"></div>
                        <div>
                          <p>
                            <button
                              className="es-button primary"
                              onClick={downloadOnboardingReport}
                              disabled={onboardingLoading}
                            >
                              {onboardingLoading ? "Preparing..." : "Download"}
                            </button>
                          </p>
                        </div>
                        {onboardingError && (
                          <div className="margin-top-10" style={{ color: "red" }}>
                            {onboardingError}
                          </div>
                        )}
                      </div>

                    </div>

                  }
                  {nav.productSearch && <div><ProductRetrieve /></div>}
                  {nav.userSearch && <div><AdminCred /></div>}
                  {nav.productUpload && <div><ProductDetailsUpload /></div>}
                  {nav.productImageUpload && <div><ImageDetailsUpload /></div>}
                  {nav.orderHistory && <div> <OrderHistoryAdmin /></div>}
                  {nav.userUpload && <div><User /></div>}
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
};

export default DownloadReports;
